module.exports = __webpack_public_path__ + "513aa607d398efaccc559916c3431403.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fortawesome/fontawesome-free/webfonts/fa-brands-400.ttf
// module id = 451
// module chunks = 0